import { Site } from '@ps/web-core-enums';
import { ResolverTag } from '@ps/web-core-store';
import React from 'react';
import { useSelector } from 'react-redux';

import Translation from '@swf/components/Translation/Translation';
import useOpenWindow from '@swf/core/hooks/useOpenWindow';
import { select } from '@swf/core/store';
import { translatedLink } from '@swf/core/utils';

import {
  TXTCLI_PokerStars_is_committed_to_sup_ELL,
  TXTCLI_Stars_Interactive_Limited_is_l_ELL,
  TXTWCL_Gaming_Account_NumberX_N0
} from './RegulatoryInformation.messages.json';
import { italianLicense, wrapper } from './RegulatoryInformation.scss';

const RegulatoryInformation: React.FC = () => {
  const site = useSelector(select.cms.getSiteId);
  const gamingAccountNumber = useSelector(select.account.getGamingAccountNumber);

  const resolverTag = {
    [Site.UK]: ResolverTag.UKLicenseAccountNumber,
    [Site.IT]: ResolverTag.HelpResponsibleGaming
  };

  const openWindow = useOpenWindow({
    resolverTag: resolverTag[site],
    openTab: true
  });

  const message = {
    [Site.UK]: (
      <Translation
        {...TXTCLI_Stars_Interactive_Limited_is_l_ELL}
        values={{ a: translatedLink({ onClick: openWindow }) }}
      />
    ),
    [Site.IT]: (
      <div className={italianLicense}>
        <Translation
          tagName="div"
          {...TXTWCL_Gaming_Account_NumberX_N0}
          values={{ 0: gamingAccountNumber }}
        />{' '}
        <Translation
          tagName="div"
          {...TXTCLI_PokerStars_is_committed_to_sup_ELL}
          values={{ a: translatedLink({ onClick: openWindow }) }}
        />
      </div>
    )
  };

  const regulatoryMessage = message[site] || null;

  return regulatoryMessage && <div className={wrapper}>{regulatoryMessage}</div>;
};

export default RegulatoryInformation;
